// Ported from eb-ui `src/legacy/OrganizerUi/CopyUrlButton.tsx`.
//   - `react-transition-group` `CSSTransition` (NOT installable in Valkyrie) →
//     a simple `useState` + `setTimeout` for the cosmetic toast.
//   - The copy-to-clipboard behaviour stays on the real `@eventbrite/legacy-eds.copy-button`
//     `CopyButton` (it owns the clipboard write + the `onCopyClick` seam).
//   - `@eventbrite/legacy-infra.i18n` → `@/lib/gettext`; icons → `../lib/iconography`.
import { CopyButton } from '@eventbrite/legacy-eds.copy-button';
import React, { useContext, useEffect, useState } from 'react';

import { AnalyticsAction, AnalyticsCategory, trackEvent } from '../_shared';
import { ApplicationContext } from '../context';
import { Icon } from '../lib/iconography';
import { CheckChunky, CopyChunky } from '../lib/iconography';
import { gettext } from '@/lib/gettext';
import type { CollectionServerData } from '@/types';

export const CopyUrlButton: React.FC = () => {
    const [copied, setCopied] = useState(false);
    const context = useContext(ApplicationContext) as
        | CollectionServerData
        | null;
    const toastDuration = 3000;

    useEffect(() => {
        if (copied) {
            const timer = setTimeout(() => {
                setCopied(false);
            }, toastDuration);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [copied]);

    return (
        <>
            <CopyButton
                value={context?.collection.url || ''}
                render={() => (
                    <button className="cc-copy-button">
                        <Icon type={<CopyChunky />} />
                        <span className="cc-copy-button__text">
                            {gettext('Copy link')}
                        </span>
                    </button>
                )}
                onCopyClick={() => {
                    setCopied(true);
                    trackEvent({
                        category: AnalyticsCategory.Listing,
                        action: AnalyticsAction.CopyURL,
                        label: 'organizer-banner',
                    });
                }}
            />
            {copied && <Toast />}
        </>
    );
};

export const Toast = () => {
    return (
        <div data-spec="toast" className="cc-toast">
            <div className="eds-l-pad-left-3">
                <Icon size="xsmall" type={<CheckChunky />} color="white" />
            </div>
            <span className="eds-text-color--white eds-l-pad-left-1">
                {gettext('Collection link copied')}
            </span>
        </div>
    );
};
